import { Checkbox } from '@material-tailwind/react';

export interface IsCheckedProps {
  id: number;
  key?: string;
  name?: string;
  filter?: string;
  nested?: any;
  isChecked: boolean;
}
interface CheckBoxProps {
  type?: 'full' | 'border' | 'rounded';
  id?: string;
  index?: number;
  value?: string;
  checked?: boolean;
  color?: 'purple5' | 'skyblue' | 'orange' | 'orange4' | 'gray9' | 'red5';
  labelValue?: React.ReactNode;
  children?: React.ReactNode;
  borderWidth?: number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  disabled?: boolean;
  /** 필수 체크를 하지 않은 오류 상태. 테두리와 라벨을 빨갛게 표시한다. */
  error?: boolean;
}

export default function CheckBoxes({
  type,
  id,
  index,
  value,
  checked,
  color = 'purple5',
  labelValue,
  children,
  borderWidth,
  onChange,
  className,
  disabled,
  error,
}: CheckBoxProps) {
  let colorClassName = '';
  switch (type) {
    case 'full':
      colorClassName = `border border-[${borderWidth}px] border-${color} bg-white rounded-[3px] before:hidden checked:bg-${color} checked:border-${color}`;
      break;
    case 'border':
      colorClassName = `border border-[${borderWidth}px] rounded-[3px] border-${color} checked:bg-white checked:border-${color}`;
      break;
    case 'rounded':
      colorClassName = `border-solid border-[${borderWidth}px] rounded-full bg-white border-${color} checked:bg-${color} checked:border-${color} w-[25px] h-[25px] before:hidden outline-none transition-colors`;
      break;
  }

  // 색상 클래스는 위에서 문자열로 조합하므로, 오류 색은 뒤에 !important 로 덧씌운다.
  const errorClassName = error ? '!border-red5' : '';

  return (
    <>
      {
        <Checkbox
          id={id}
          value={value}
          className={`${colorClassName} ${errorClassName} ${className}`}
          onChange={(e) => onChange(e)}
          checked={checked}
          label={
            <div
              className={`whitespace-wrap text-[14px] font-semibold leading-[22px] tracking-[-0em] ${
                error ? 'text-red5' : 'text-black'
              }`}
            >
              {labelValue}
            </div>
          }
          iconProps={{
            className: `${type === 'border' ? 'text-purple5' : 'text-white'} `,
          }}
          containerProps={{
            className: `p-[2px] ${type === 'rounded' ? 'rounded-full' : 'rounded-[3px]'}`,
          }}
          labelProps={{
            className: 'm-0 ml-[8px]',
          }}
          ripple={type !== 'rounded'}
          disabled={disabled}
        >
          {children}
        </Checkbox>
      }
    </>
  );
}
